import React, { useMemo, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { setCurrentStep, setShowPopUp, setCurrentPopUp, updateOwnershipTransferRequest, setContactPersonSendFormType, setSubscriberSendFormType } from '../OwnershipTransferSlice'
import { PopupEnum, PopupMessageContent, RequestStatus, RequestStatusDescription, OwnershipTransferActionType, OwnershipTransferActionTypeDescription, EquipmentPaymentObligation, OwnershipTransferStep, FormSendType, UpdateFormType } from '../Constant/Constant'
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BtnWhiteBlackBorderBigSize from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import { convertDateTimeToDate } from '../../../../utilities/StringHelpers/StringHelpers';
import SelectOptionExtendedButton from '../../../Shared/SelectOptionExtendedButton/SelectOptionExtendedButton';
import { validateInput, TextInputEnum } from '../../../../utilities/validation/InputValidation';
import { dwhDashboardReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'


const RequestDataRow = (props) => {
  return (
    <div className='request-data-row'>
      <div className='request-data-row-title'>{props.title}</div>
      <div className='request-data-row-text'>{props.text}</div>
    </div>
  )
}

const RowValidationResult = (props) => {
  const row = props.data.currentPopupData;
  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhDashboardReport({
        data: { row: row, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.StatusTable,
        messageText: DWHMessageText.PopupDataLineDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, [])

  const popupTypes = {
    AllowedToFullEditing: 'allowedToFullEditing',
    AllowedToCancel: 'allowedToCancel',
    Expired: 'expired',
    Finished: 'finished'
  }
  const popupType = useMemo(() => getPopupType(), []);
  const numberRegex = /^\d+$/;
  function recognizeStringType(input) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmail = emailRegex.test(input);
    const isPhoneNumber = input.startsWith('05');

    if (isEmail) {
      return FormSendType.email;
    } else if (isPhoneNumber) {
      return FormSendType.sms;
    }
  }
  const initialCPButtons = [
    {
      id: '0',
      label: 'SMS',
      value: FormSendType.sms,
      selected: false,
      textInputValidationType: TextInputEnum.Phone,
      onChange: inputChangeHandler,
      inputValue: recognizeStringType(row.contactPersonFormMethodValue) == FormSendType.sms ? row.contactPersonFormMethodValue : '',
      pattern: '[0-9]*',
      maxLength: '10'
    },
    {
      id: '1',
      label: 'מייל',
      value: FormSendType.email,
      selected: false,
      textInputValidationType: TextInputEnum.Mail,
      onChange: inputChangeHandler,
      inputValue: recognizeStringType(row.contactPersonFormMethodValue) == FormSendType.email ? row.contactPersonFormMethodValue : '',
    }
  ];

  const initialSubscriberButtons = [
    {
      id: '0',
      label: row.statusCodeDescription == RequestStatus.AwaitingForJoin || row.statusCodeDescription == RequestStatus.SignedAwaitingForJoin ? `SMS <span class='disabled'> ל-${row.subscriberPhoneNumber}</span> ` : 'SMS',
      value: FormSendType.sms,
      selected: false,
      textInputValidationType: TextInputEnum.Phone,
      onChange: inputChangeHandler,
      inputValue: row.statusCodeDescription == RequestStatus.AwaitingForJoin || row.statusCodeDescription == RequestStatus.SignedAwaitingForJoin ? row.subscriberPhoneNumber : recognizeStringType(row.subscriberFormMethodValue) == FormSendType.sms ? row.subscriberFormMethodValue : '',
      pattern: '[0-9]*',
      maxLength: '10',
      disabled: row.statusCodeDescription == RequestStatus.AwaitingForJoin || row.statusCodeDescription == RequestStatus.SignedAwaitingForJoin ? true : false
    },
    {
      id: '1',
      label: 'מייל',
      value: FormSendType.email,
      selected: false,
      textInputValidationType: TextInputEnum.Mail,
      onChange: inputChangeHandler,
      inputValue: recognizeStringType(row.subscriberFormMethodValue) == FormSendType.email ? row.subscriberFormMethodValue : '',
    },
  ]

  const [errors, setErrors] = useState({ sms: '', email: '' });
  const [buttons, setButtons] = useState(row.statusCodeDescription == RequestStatus.AwaitingContactPersonSignature ? initialCPButtons : initialSubscriberButtons);
  const [showErrorMsg, setShowErrorMsg] = useState(false);



  function getPopupType() {
    switch (row.statusCodeDescription) {
      case RequestStatus.AwaitingContactPersonSignature:
      case RequestStatus.AwaitingSubscriberSignature:
      case RequestStatus.AwaitingForJoin:
      case RequestStatus.SignedAwaitingForJoin:
        return popupTypes.AllowedToFullEditing
      case RequestStatus.Signed:
        return popupTypes.AllowedToCancel
      case RequestStatus.Expired:
        return popupTypes.Expired
      case RequestStatus.Finished:
      case RequestStatus.TransferredForManualProcessing:
        return popupTypes.Finished

    }
  }

  function getClassName() {
    switch (row.statusCodeDescription) {
      case RequestStatus.AwaitingContactPersonSignature:
      case RequestStatus.AwaitingForJoin:
      case RequestStatus.SignedAwaitingForJoin:
        return 'orange'
      case RequestStatus.AwaitingSubscriberSignature:
        return 'yellow'
      case RequestStatus.Signed:
        return 'green'
      case RequestStatus.Expired:
        return 'red'
      case RequestStatus.Finished:
      case RequestStatus.TransferredForManualProcessing:
        return 'purple'
    }
  }


  function inputChangeHandler(type, value, error) {
    if (type === FormSendType.sms && value && !numberRegex.test(value)) { return null; }
    setButtons((buttonsData) => buttonsData.map((btn) => (btn.value === type ? { ...btn, inputValue: value } : btn)));
    setErrors({ ...errors, [type]: error });
    setShowErrorMsg(false);
  }

  function manageData(value) {
    let newButtonData = buttons.map((button) => {
      if (button.value === value) {
        button.selected = true;
      } else {
        button.selected = false;
      }
      return button;
    });
    setButtons(newButtonData);
  }

  function editRequest() {
    if (!validateRequiredData()) {
      setShowErrorMsg(true);
      return;
    }

    dwhDashboardReport({
      data: { row: row, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
      actionType: DwhActionType.StatusTable,
      messageText: DWHMessageText.ResendingButtonClicked,
      status: DWHStatus.Ongoing,

    });

    const editRes = {
      RequestId: row.id,
      SubscriberNumber: row.subscriberPhoneNumber,
      UpdateType: getUpdateFormType(),
      FormMethod: buttons.find((btn) => btn.selected)?.value,
      FormMethodValue: buttons.find((btn) => btn.selected)?.inputValue,
    }
    setShowErrorMsg(false);
    props.updateOwnershipTransferRequest(editRes);

  }
  function validateRequiredData() {
    if (row.statusCodeDescription == RequestStatus.AwaitingForJoin || row.statusCodeDescription == RequestStatus.SignedAwaitingForJoin) {
      return true;
    }
    let selectedFormSendType = buttons.find((button) => button.selected);
    if (!selectedFormSendType || !selectedFormSendType.inputValue || errors[selectedFormSendType.value]) {
      return false;
    }
    return true;

  }

  function getUpdateFormType() {
    const selectedSendTypeButton = buttons.find((btn) => btn.selected);
    const formMethod = selectedSendTypeButton?.value;
    const formMethodValue = selectedSendTypeButton?.inputValue;
    if (row.statusCodeDescription == RequestStatus.AwaitingContactPersonSignature) {
      //set form value data for for usage in success page
      props.setContactPersonSendFormType({ type: formMethod, value: formMethodValue });
      props.setSubscriberSendFormType({ type: recognizeStringType(row.subscriberFormMethodValue) == FormSendType.email ? FormSendType.email : FormSendType.sms, value: row.subscriberFormMethodValue });

      if (row.contactPersonFormMethodValue == formMethodValue?.trim()) {
        return UpdateFormType.SendOnly
      }
      else {

        return UpdateFormType.UpdateAndSend
      }

    }
    else if (row.statusCodeDescription == RequestStatus.AwaitingSubscriberSignature) {
      //set form value data for usage in success page
      props.setSubscriberSendFormType({ type: formMethod, value: formMethodValue });
      if (row.subscriberFormMethodValue == formMethodValue?.trim()) {
        return UpdateFormType.SendOnly
      }
      else {
        return UpdateFormType.UpdateAndSend
      }
    }
    else if (row.statusCodeDescription == RequestStatus.AwaitingForJoin || row.statusCodeDescription == RequestStatus.SignedAwaitingForJoin) {
      if (!selectedSendTypeButton) {
        props.setSubscriberSendFormType({ type: FormSendType.sms, value: row.subscriberPhoneNumber });
      }
      else {
        props.setSubscriberSendFormType({ type: formMethod, value: formMethodValue });
      }
      return UpdateFormType.SendML
    }
  }

  async function cancelRequest() {
    dwhDashboardReport({
      data: { row: row, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
      actionType: DwhActionType.StatusTable,
      messageText: DWHMessageText.CancelTransferButtonClicked,
      status: DWHStatus.Ongoing,

    });
    await props.setShowPopUp(false);
    props.setCurrentPopUp(
      {
        currentPopUp: PopupEnum.CustomerValidationResult,
        currentPopupData: PopupMessageContent.CancelOwnershipTransfer
      }
    )

  }
  function getEquipmentTitle() {
    if (row.equipmentObligations == EquipmentPaymentObligation.None) {
      return 'לא קיים '
    }
    if (row.actionType == OwnershipTransferActionType.BusinessToPrivate) {
      if (row.equipmentObligations == EquipmentPaymentObligation.Customer) {
        return 'מועבר למנוי'
      }
      else {
        return 'נשאר בחברה'
      }
    }
  }
  function getButtonsTitle() {
    if (row.statusCodeDescription == RequestStatus.AwaitingSubscriberSignature
      || row.statusCodeDescription == RequestStatus.AwaitingForJoin
      || row.statusCodeDescription == RequestStatus.SignedAwaitingForJoin
    ) {
      return 'אפשר לשלוח שוב את הטופס לחתימת המנוי'
    }
    else {
      return 'לאן לשלוח את הטופס לחתימה שלך?'
    }

  }

  return (
    <div className='row-validation-result'>
      <div className='l-title'>סטטוס העברת בעלות</div>
      <div className='popup-status-description-wrapper'>
        <div className={`${getClassName()} popup-status-description`}>
          <div className={`s-title semi`}>{RequestStatusDescription[row.statusCodeDescription]}</div>
        </div>
        {(popupType == popupTypes.Finished && row.statusCodeDescription == RequestStatus.TransferredForManualProcessing) &&
          <div className={`s-title`}>מספר הוראת עבודה: {row.fU_Number}</div>}
      </div>


      <div className='request-data'>
        <RequestDataRow title='תאריך שליחה:' text={convertDateTimeToDate(row.createData)} />
        <RequestDataRow title='שם מנוי:' text={`${row.subscriberFirstName} ${row.subscriberLastName}`} />
        <RequestDataRow title='ת.ז מנוי:' text={row.subscriberIdNumber} />
        <RequestDataRow title='מספר מנוי :' text={row.subscriberPhoneNumber?.replace(/^(.{3})(.*)$/, '$1-$2')} />
        <RequestDataRow title='סוג העברת בעלות:' text={OwnershipTransferActionTypeDescription[row.actionType]} />
        <RequestDataRow title='חיובי ציוד:' text={getEquipmentTitle()} />
      </div>
      {popupType == popupTypes.Expired && <><div className='s-title'>שימו לב, במידה ותרצו להשלים העברת בעלות בעתיד, תצטרכו לבצע העברה חדשה</div>
        <div className='row-validation-result-buttons flex'>
          <BtnWhiteBlackBorderBigSize text='חזרה לטבלת הסטטוס' onclick={() => { props.setShowPopUp(false) }} />
          <BtnSubmit text='העברת בעלות חדשה' onclick={() => { props.setCurrentStep(OwnershipTransferStep.SelectActionType); props.setShowPopUp(false) }} />
        </div>
      </>
      }
      {popupType == popupTypes.Finished &&
        <div className='row-validation-result-buttons'>
          <BtnSubmit text='סיום' onclick={() => { props.setShowPopUp(false) }} />
        </div>
      }
      {popupType == popupTypes.AllowedToFullEditing && <>
        <div className='edit-request-inputs'>
          <SelectOptionExtendedButton title={getButtonsTitle()} buttonsData={buttons} onClick={manageData} />
        </div>
        <div>
          <div className='row-validation-result-buttons'>
            {showErrorMsg && <div className='error center'>כדי להמשיך יש למלא את כל שדות החובה</div>}
            <BtnSubmit text='שליחה' onclick={() => { editRequest() }} />
          </div>
          <div>
            <a className='cancel-request general-message-link' onClick={() => { cancelRequest(); props.setShowPopUp(false) }}>ביטול בקשה להעברת המנוי </a>
          </div>

        </div>
      </>}
      {popupType == popupTypes.AllowedToCancel && <>
        <div className='row-validation-result-buttons'>
          <BtnSubmit text='סיום' onclick={() => { props.setShowPopUp(false) }} />
        </div>
        <div>
          <a className='cancel-request general-message-link' onClick={() => { cancelRequest(); props.setShowPopUp(false) }}>ביטול בקשה להעברת המנוי </a>
        </div>
      </>}
    </div>
  );
};


const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  authentication: state.authentication,
  userDetails: state.authentication?.loginData?.userDetails,
  portalsBlock: state.portalsBlock,

});

const mapDispatchToProps = {
  setCurrentStep, setShowPopUp, setCurrentPopUp, updateOwnershipTransferRequest, setContactPersonSendFormType, setSubscriberSendFormType
};

export default connect(mapStateToProps, mapDispatchToProps)(RowValidationResult);

